import { render, staticRenderFns } from "./over-ons.vue?vue&type=template&id=4023768b&scoped=true&"
import script from "./over-ons.vue?vue&type=script&lang=js&"
export * from "./over-ons.vue?vue&type=script&lang=js&"
import style0 from "./over-ons.vue?vue&type=style&index=0&id=4023768b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4023768b",
  null
  
)

/* custom blocks */
import block0 from "./over-ons.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHeader: require('/app/components/page/header.vue').default,UiTransition: require('/app/components/ui/transition.vue').default,UiIcon: require('/app/components/ui/icon.vue').default})
